var _CancellationToken_onCancelled, _CancellationToken_cancelled;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import SingleInvokeEvent from '../Events/SingleInvokeEvent';
export default class CancellationToken {
    /**
     *
     */
    constructor(cancelledEvent) {
        _CancellationToken_onCancelled.set(this, new SingleInvokeEvent());
        _CancellationToken_cancelled.set(this, false);
        cancelledEvent === null || cancelledEvent === void 0 ? void 0 : cancelledEvent.addHandler(() => {
            __classPrivateFieldSet(this, _CancellationToken_cancelled, true, "f");
            __classPrivateFieldGet(this, _CancellationToken_onCancelled, "f").invoke(this, undefined);
        });
    }
    get onCancelled() {
        return __classPrivateFieldGet(this, _CancellationToken_onCancelled, "f");
    }
    get isCancellationRequested() {
        return __classPrivateFieldGet(this, _CancellationToken_cancelled, "f");
    }
}
_CancellationToken_onCancelled = new WeakMap(), _CancellationToken_cancelled = new WeakMap();
CancellationToken.default = new CancellationToken();
